import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const IMAGE_ASPECT_RATIO = 4 / 5;
const imageWidth = 110;

const style = () => {
  const {
    borderWidth1,
    borderWidth2,
    borderRadius3,
    colorBorderInteractive,
    colorTextMedium,
    colorBorderInteractiveSelected,
    space05,
    space2,
    space5,
  } = theme();

  return StyleSheet.create({
    image: {
      borderColor: colorBorderInteractive,
      borderRadius: space2,
      borderWidth: borderWidth1,
      flex: 1,
    },
    imageWrapper: {
      aspectRatio: IMAGE_ASPECT_RATIO,
      paddingBottom: space2,
      paddingRight: space2,
    },
    moreColors: {
      alignItems: "center",
      borderColor: colorBorderInteractive,
      borderRadius: borderRadius3,
      borderWidth: borderWidth1,
      bottom: space2,
      display: "flex",
      flex: 1,
      justifyContent: "center",
      left: 0,
      position: "absolute",
      right: space2,
      top: 0,
    },
    moreColorsButton: {
      aspectRatio: IMAGE_ASPECT_RATIO,
    },
    moreColorsText: {
      color: colorTextMedium,
      textAlign: "center",
    },
    oneSixth: {
      minWidth: "16.66666666666667%",
    },
    selectedImage: {
      borderColor: colorBorderInteractiveSelected,
      borderWidth: borderWidth2,
      paddingHorizontal: space05,
    },
    wrapper: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      marginBottom: space5,
    },
  });
};

export { style, imageWidth };
